import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaHourglassHalf, FaTimesCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { toast } from "react-toastify";

const AdvertiserDashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [runningAds, setRunningAds] = useState([]);
  const [error, setError] = useState(null);
  const [ads, setAds] = useState([]);

  const [advertisements, setAdvertisements] = useState([]);

  // Calculate stats from advertisements data
  const stats = {
    underReviewAds: advertisements.filter((ad) => ad.status === "pending").length,
    pendingAds: advertisements.filter((ad) => ad.status === "approved").length,
    rejectedAds: advertisements.filter((ad) => ad.status === "rejected").length,
    completedAds: advertisements.filter((ad) => ad.status === "completed").length,
  };

  // Fetch all ads counts
  useEffect(() => {
    const fetchAdCounts = async () => {
      try {
        const allAdsResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/advertiser/get/all/ads`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        console.log("All Ads Response:", allAdsResponse);

        setAdvertisements(allAdsResponse.data);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching ad data:", error);
      }
    };

    fetchAdCounts();
  }, []);

  // Get the Stats for accepted by reporter ads
  useEffect(() => {
    const fetchAds = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/ads/accepted/by/reporters/for/advertiser`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Fetched accepted reporter ads:", response.data);
        // Ensure ads is always an array
        const adsData =
          Array.isArray(response.data.data) && response.data.data.length > 0
            ? response.data.data
            : Array.isArray(response.data) && response.data.length > 0
              ? response.data
              : [];
        setAds(adsData);
      } catch (err) {
        setError("Failed to fetch ads");
      } finally {
        setLoading(false);
      }
    };
    fetchAds();
  }, []);




  // Fetch running ads counts
  useEffect(() => {
    const fetchRunningAdsCounts = async () => {
      try {
        const runningAdsResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/get/running/ads`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        console.log("Running Ads Response:", runningAdsResponse);

        setRunningAds(runningAdsResponse.data.data || []);
        console.log("Running Ads:", runningAdsResponse.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching ad data:", error);
      }
    };

    fetchRunningAdsCounts();
  }, []);

  // Handle card click to navigate to specific pages
  const handleCardClick = (type) => {
    switch (type) {
      case "pending":
        navigate("/advertiser/leads-status/pending");
        break;
      case "accepted":
        navigate("/advertiser/leads-status/accepted");
        break;
      case "UnderReview":
        navigate("/advertiser/leads-status/underReview");
        break;

      case "completed":
        navigate("/advertiser/leads-status/completed");
        break;
      case "rejected":
        navigate("/advertiser/leads-status/rejected");
        break;
      case "running":
        navigate("/advertiser/leads-status/running");
        break;
      default:
        break;
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl sm:text-2xl font-black text-gray-900 tracking-tight">
            Ad Performance
          </h1>
          <p className="text-sm text-gray-500 font-medium">Overview of your current advertisement campaigns</p>
        </div>
      </div>

      {/* Stats Cards - Compact grid for mobile */}
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4 md:gap-6">
        {/* Under Review Ads */}
        <button
          className="group relative bg-white p-4 rounded-2xl border border-orange-100 shadow-sm hover:shadow-md transition-all active:scale-95 text-left overflow-hidden"
          onClick={() => handleCardClick("UnderReview")}
        >
          <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
            <FaHourglassHalf className="w-10 h-10 text-orange-600" />
          </div>
          <p className="text-[10px] sm:text-xs font-bold text-orange-600 uppercase tracking-wider mb-1">Under Review</p>
          <p className="text-xl sm:text-2xl font-black text-gray-900">
            {loading ? "0" : stats.underReviewAds}
          </p>
        </button>

        {/* Pending Ads */}
        <button
          className="group relative bg-white p-4 rounded-2xl border border-yellow-100 shadow-sm hover:shadow-md transition-all active:scale-95 text-left overflow-hidden"
          onClick={() => handleCardClick("pending")}
        >
          <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
            <FaHourglassHalf className="w-10 h-10 text-yellow-600" />
          </div>
          <p className="text-[10px] sm:text-xs font-bold text-yellow-600 uppercase tracking-wider mb-1">Approved</p>
          <p className="text-xl sm:text-2xl font-black text-gray-900">
            {loading ? "0" : stats.pendingAds}
          </p>
        </button>

        {/* Accepted by Reporter Ads */}
        <button
          className="group relative bg-white p-4 rounded-2xl border border-green-100 shadow-sm hover:shadow-md transition-all active:scale-95 text-left overflow-hidden"
          onClick={() => handleCardClick("accepted")}
        >
          <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
            <FaCheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <p className="text-[10px] sm:text-xs font-bold text-green-600 uppercase tracking-wider mb-1">Accepted</p>
          <p className="text-xl sm:text-2xl font-black text-gray-900">
            {loading ? "0" : (Array.isArray(ads) ? ads.length : 0)}
          </p>
        </button>

        {/* Running Leads */}
        <button
          className="group relative bg-white p-4 rounded-2xl border border-blue-100 shadow-sm hover:shadow-md transition-all active:scale-95 text-left overflow-hidden"
          onClick={() => handleCardClick("running")}
        >
          <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
            <FaHourglassHalf className="w-10 h-10 text-blue-600" />
          </div>
          <p className="text-[10px] sm:text-xs font-bold text-blue-600 uppercase tracking-wider mb-1">Running</p>
          <p className="text-xl sm:text-2xl font-black text-gray-900">
            {loading ? "0" : (Array.isArray(runningAds) ? runningAds.length : 0)}
          </p>
        </button>

        {/* Completed Leads */}
        <button
          className="group relative bg-white p-4 rounded-2xl border border-emerald-100 shadow-sm hover:shadow-md transition-all active:scale-95 text-left overflow-hidden"
          onClick={() => handleCardClick("completed")}
        >
          <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
            <FaCheckCircle className="w-10 h-10 text-emerald-600" />
          </div>
          <p className="text-[10px] sm:text-xs font-bold text-emerald-600 uppercase tracking-wider mb-1">Completed</p>
          <p className="text-xl sm:text-2xl font-black text-gray-900">
            {loading ? "0" : stats.completedAds}
          </p>
        </button>

        {/* Rejected Leads */}
        <button
          className="group relative bg-white p-4 rounded-2xl border border-red-100 shadow-sm hover:shadow-md transition-all active:scale-95 text-left overflow-hidden"
          onClick={() => handleCardClick("rejected")}
        >
          <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
            <FaTimesCircle className="w-10 h-10 text-red-600" />
          </div>
          <p className="text-[10px] sm:text-xs font-bold text-red-600 uppercase tracking-wider mb-1">Rejected</p>
          <p className="text-xl sm:text-2xl font-black text-gray-900">
            {loading ? "0" : stats.rejectedAds}
          </p>
        </button>
      </div>

      {/* Quick Actions / Info */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pb-20 sm:pb-8">
        <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
          <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
            <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
            Manage Your Brand
          </h3>
          <div className="space-y-4">
            <p className="text-sm text-gray-600 leading-relaxed">
              Track your advertisement lifecycle from submission to completion. Ensure your wallet has sufficient balance to keep your ads running smoothly.
            </p>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => navigate("/advertiser/post/advertisement")}
                className="p-3 bg-blue-50 text-blue-700 rounded-xl text-xs font-bold hover:bg-blue-100 transition-colors"
              >
                + New Ad
              </button>
              <button
                onClick={() => navigate("/advertiser/addmoney")}
                className="p-3 bg-green-50 text-green-700 rounded-xl text-xs font-bold hover:bg-green-100 transition-colors"
              >
                Top up Wallet
              </button>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-indigo-600 to-purple-700 p-6 rounded-3xl text-white shadow-xl shadow-indigo-200">
          <h3 className="text-lg font-bold mb-2">Need Assistance?</h3>
          <p className="text-sm text-indigo-100 mb-6 font-medium">Our support team is available 24/7 to help you with your campaigns.</p>
          <button
            onClick={() => navigate("/contact")}
            className="w-full py-3 bg-white text-indigo-600 rounded-xl text-sm font-black shadow-lg active:scale-95 transition-transform"
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdvertiserDashboard;
